import React from 'react';
import LineChart, {chartContent} from "../../../../common/component/LineChart";
import {QueryKey} from "@tanstack/react-query";
import {useCommonUseQuery} from "../../../../../../../Common/hooks/rest/ReacQueryHook";
import {procAdminService} from "../../../../../../../Common/util/ProcService";

const ThisQuarterSizeDashBoard: React.FC = () => {
    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;
    const queryKey:QueryKey =   ["ThisQuarterSizeDashBoardKey"];
    const { data } = useCommonUseQuery<chartContent[]>(
        queryKey,
        () =>procAdminService<chartContent[]>("post", `${serviceCode}ADS03`, null));

    const quarterCategory = [
        '1/4','2/4','3/4','4/4',
    ]

    const quarterSeries:chartContent[] =    data ? data :
                                                [
                                                    {
                                                        name: "2022년",
                                                        data: [
                                                            0, 0, 0, 0
                                                        ],
                                                    },
                                                    {
                                                        name: "2023년",
                                                        data: [
                                                            0, 0, 0, 0
                                                        ],
                                                    },
                                                ]



    return (
        <LineChart title="분기별 업로드 현황 (용량-GB)" key={3} unit="GB" categories={quarterCategory} series={quarterSeries} dataLabels={true}/>
    );
};

export default ThisQuarterSizeDashBoard;
